import styled from 'styled-components';

export const ListWrapper = styled.div<{ width: string }>`
  width: ${props => props.width};
`;

export const VerticalList = styled.div<{
  listSpacing: string;
  $overflow: boolean;
  height: string;
  headerSpacing: string;
  footerSpacing: string;
}>`
  overflow: ${props => props.$overflow && 'scroll'};
  height: ${props => props.height};

  > * {
    margin-top: ${props => props.listSpacing || '0px'};
  }

  > *:first-child {
    margin-top: ${props => props.headerSpacing || '0px'};
  }

  > *:last-child {
    margin-bottom: ${props => props.footerSpacing || '0px'};
  }
`;

export const HorizontalList = styled.div<{
  $overflow: boolean;
  width: string;
  listSpacing: string;
  listWrapSpacing: string;
}>`
  white-space: ${props => props.$overflow && 'nowrap'};
  overflow: ${props => props.$overflow && 'scroll'};
  width: ${props => props.width};

  -ms-overflow-style: none; // IE 10+
  scrollbar-width: none; // Firefox

  ::-webkit-scrollbar {
    display: none; // Safari and Chrome
  }

  > * {
    display: inline-flex;
    margin-right: ${props => props.listSpacing || '0px'};
    margin-top: ${props => props.listWrapSpacing || '0px'};
  }

  > *:last-child {
    margin-right: 0px;
  }
`;
